"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarthCatapultRebalanced = void 0;
var Tags_1 = require("../../Tags");
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var EarthCatapultRebalanced = (function (_super) {
    __extends(EarthCatapultRebalanced, _super);
    function EarthCatapultRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.EARTH_CATAPULT_REBALANCED,
            tags: [Tags_1.Tags.EARTH],
            cost: 28,
            cardDiscount: { amount: 2 },
            metadata: {
                cardNumber: '070',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you play a card, you pay 2 M€ less for it.', function (eb) {
                        eb.empty().startEffect.megacredits(-2);
                    });
                }),
                victoryPoints: 1,
            },
        }) || this;
    }
    EarthCatapultRebalanced.prototype.getCardDiscount = function () {
        return 2;
    };
    EarthCatapultRebalanced.prototype.play = function () {
        return undefined;
    };
    EarthCatapultRebalanced.prototype.getVictoryPoints = function () {
        return 1;
    };
    return EarthCatapultRebalanced;
}(Card_1.Card));
exports.EarthCatapultRebalanced = EarthCatapultRebalanced;
//# sourceMappingURL=EarthCatapultRebalanced.js.map